/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Competitors } from '../models/competitors';


/**
 * Provides Competitor Premium information
 */
@Injectable({
  providedIn: 'root',
})
export class CompetitorPremiumApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCompetitorsForWebsite
   */
  static readonly GetCompetitorsForWebsitePath = '/v1/company/competitorpremium/url/{website}';

  /**
   * Get Competitor information by Domain.
   *
   * The Competitors API provides basic information about all competitors of a given company Domain
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompetitorsForWebsite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompetitorsForWebsite$Response(params: {

    /**
     * Domain
     */
    website: string;

    /**
     * Pass pagination_id as * in the first API request. The API response will return top competitors along with the next pagination_id which can be passed in the subsequent API request to get the next set of competitors. Repeat this process until needed or till the pagination_id returned is blank. Note:Every response will have maximum of 50 competitors.
     */
    pagination_id?: string;

    /**
     * Format of the response content - json (by default if not specified), xml
     */
    format?: 'json' | 'xml';
  }): Observable<StrictHttpResponse<Competitors>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitorPremiumApiService.GetCompetitorsForWebsitePath, 'get');
    if (params) {
      rb.path('website', params.website, {});
      rb.query('pagination_id', params.pagination_id, {});
      rb.query('format', params.format, {});
      rb.header('x-api-key','nBgJEqk8fI2nR0gknT79n6wMyBJ4Cbrf6CWo2h9u');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Competitors>;
      })
    );
  }

  /**
   * Get Competitor information by Domain.
   *
   * The Competitors API provides basic information about all competitors of a given company Domain
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompetitorsForWebsite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompetitorsForWebsite(params: {

    /**
     * Domain
     */
    website: string;

    /**
     * Pass pagination_id as * in the first API request. The API response will return top competitors along with the next pagination_id which can be passed in the subsequent API request to get the next set of competitors. Repeat this process until needed or till the pagination_id returned is blank. Note:Every response will have maximum of 50 competitors.
     */
    pagination_id?: string;

    /**
     * Format of the response content - json (by default if not specified), xml
     */
    format?: 'json' | 'xml';
  }): Observable<Competitors> {

    return this.getCompetitorsForWebsite$Response(params).pipe(
      map((r: StrictHttpResponse<Competitors>) => r.body as Competitors)
    );
  }

  /**
   * Path part for operation getCompetitorsForId
   */
  static readonly GetCompetitorsForIdPath = '/v1/company/competitorpremium/id/{companyId}';

  /**
   * Get Competitor information by Id.
   *
   * The Competitors API provides basic information about all competitors of a given company Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompetitorsForId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompetitorsForId$Response(params: {

    /**
     * Pass pagination_id as * in the first API request. The API response will return top competitors along with the next pagination_id which can be passed in the subsequent API request to get the next set of competitors. Repeat this process until needed or till the pagination_id returned is blank. Note:Every response will have maximum of 50 competitors.
     */
    pagination_id?: string;

    /**
     * Format of the response content - json (by default if not specified), xml
     */
    format?: 'json' | 'xml';

    /**
     * Owler Id (e.g. 100486)
     */
    companyId: string;
  }): Observable<StrictHttpResponse<Competitors>> {

    const rb = new RequestBuilder(this.rootUrl, CompetitorPremiumApiService.GetCompetitorsForIdPath, 'get');
    if (params) {
      rb.query('pagination_id', params.pagination_id, {});
      rb.query('format', params.format, {});
      rb.path('companyId', params.companyId, {});
      rb.header('x-api-key','nBgJEqk8fI2nR0gknT79n6wMyBJ4Cbrf6CWo2h9u');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Competitors>;
      })
    );
  }

  /**
   * Get Competitor information by Id.
   *
   * The Competitors API provides basic information about all competitors of a given company Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompetitorsForId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompetitorsForId(params: {

    /**
     * Pass pagination_id as * in the first API request. The API response will return top competitors along with the next pagination_id which can be passed in the subsequent API request to get the next set of competitors. Repeat this process until needed or till the pagination_id returned is blank. Note:Every response will have maximum of 50 competitors.
     */
    pagination_id?: string;

    /**
     * Format of the response content - json (by default if not specified), xml
     */
    format?: 'json' | 'xml';

    /**
     * Owler Id (e.g. 100486)
     */
    companyId: string;
  }): Observable<Competitors> {

    return this.getCompetitorsForId$Response(params).pipe(
      map((r: StrictHttpResponse<Competitors>) => r.body as Competitors)
    );
  }

}
